import { render, staticRenderFns } from "./ResizablePage.vue?vue&type=template&id=3c75da37&"
import script from "./ResizablePage.vue?vue&type=script&lang=js&"
export * from "./ResizablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports